import React from 'react'
import Image from '../components/Image'
import { Carousel } from '../components/Carousel'
import useFancybox from '../utils/useFancybox'

import './Gallery.scss'

export const Gallery = ({ id, gallery }) => {
  const [fancyboxRef] = useFancybox()

  return (
    <div className="gallery" ref={fancyboxRef}>
      {gallery && (
        <Carousel
          infinite
          autoPlay
          duration={500}
          autoPlayInterval={2500}
          autoWidth={true}
          id={id}
          responsive={{
            0: {
              items: 1,
              itemsFit: 'contain',
            },
            1024: {
              items: 1,
              itemsFit: 'contain',
            },
          }}
        >
          {gallery.map((slide, index) => (
            <div className="slide" key={index}>
              {slide.source_url ? (
                <a data-fancybox="gallery" href={slide.source_url}>
                  <Image image={slide} position="relative" />
                </a>
              ) : (
                <Image image={slide} position="relative" />
              )}
            </div>
          ))}
        </Carousel>
      )}
    </div>
  )
}
